import { Box, FormControlLabel, Switch, Tooltip } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';
import ToolTip from '../../shared/ToolTip/ToolTip';

interface EmployeeDirectoryToggleProps {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

const EmployeeDirectoryToggle: React.FC<EmployeeDirectoryToggleProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const labelText = checked
    ? t('Turn off "Employee Directory" mode')
    : t('Turn on "Employee Directory" mode');

  const label = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
      {labelText}
      <ToolTip
        title={
          checked
            ? t(
                'This will enable you to manually add transfer call entries one at a time.'
              )
            : t(
                'The employee directory mode will enable you to create an XLSX file and specify 1,500 transfer call entries maximum and upload them all at once.'
              )
        }
      />
    </Box>
  );

  return (
    <Tooltip
      title={
        disabled
          ? t('Employee Directory mode is only available for existing agents.')
          : ''
      }
    >
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={onChange}
            size="small"
            disabled={disabled}
          />
        }
        label={label}
        sx={{ margin: 0, gap: '0.5rem' }}
      />
    </Tooltip>
  );
};

export default EmployeeDirectoryToggle;
